/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ClassLevelLiteDto } from '../models/ClassLevelLiteDto';
import type { MadrasaExamAttemptHistoryResponse } from '../models/MadrasaExamAttemptHistoryResponse';
import type { MadrasaExamAttemptRequest } from '../models/MadrasaExamAttemptRequest';
import type { MadrasaExamAttemptResponse } from '../models/MadrasaExamAttemptResponse';
import type { MadrasaExamClassLevelReadyInterfaceProjection } from '../models/MadrasaExamClassLevelReadyInterfaceProjection';
import type { Page_ExaminerMadrasaExamStatusResponse_ } from '../models/Page_ExaminerMadrasaExamStatusResponse_';
import type { Page_TeacherMadrasaExamStatusResponse_ } from '../models/Page_TeacherMadrasaExamStatusResponse_';
import type { ToggleStudentExamReadinessRequest } from '../models/ToggleStudentExamReadinessRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class MadrasaExamAssessmentRestControllerService {
  /**
   * attemptExam
   * @returns any OK
   * @throws ApiError
   */
  public static attemptExamUsingPost({
    request,
  }: {
    /**
     * request
     */
    request: MadrasaExamAttemptRequest;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/madrasa-exam-assessment/attempt-exam',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getAttemptHistory
   * @returns MadrasaExamAttemptHistoryResponse OK
   * @throws ApiError
   */
  public static getAttemptHistoryUsingGet({
    studentId,
    subjectId,
  }: {
    /**
     * studentId
     */
    studentId: string;
    /**
     * subjectId
     */
    subjectId: string;
  }): CancelablePromise<MadrasaExamAttemptHistoryResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/madrasa-exam-assessment/attempt-history/{studentId}',
      path: {
        studentId: studentId,
      },
      query: {
        subjectId: subjectId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getAttempt
   * @returns MadrasaExamAttemptResponse OK
   * @throws ApiError
   */
  public static getAttemptUsingGet({
    attemptId,
  }: {
    /**
     * attemptId
     */
    attemptId: string;
  }): CancelablePromise<MadrasaExamAttemptResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/madrasa-exam-assessment/attempt/{attemptId}',
      path: {
        attemptId: attemptId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getExaminerClassReadyCounts
   * @returns MadrasaExamClassLevelReadyInterfaceProjection OK
   * @throws ApiError
   */
  public static getExaminerClassReadyCountsUsingGet({
    examinerId,
    termId,
  }: {
    /**
     * examinerId
     */
    examinerId: string;
    /**
     * termId
     */
    termId: string;
  }): CancelablePromise<Array<MadrasaExamClassLevelReadyInterfaceProjection>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/madrasa-exam-assessment/examiner-class-ready-counts',
      query: {
        examinerId: examinerId,
        termId: termId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getClassesAssignedToExaminer
   * @returns ClassLevelLiteDto OK
   * @throws ApiError
   */
  public static getClassesAssignedToExaminerUsingGet({
    examinerId,
  }: {
    /**
     * examinerId
     */
    examinerId: string;
  }): CancelablePromise<Array<ClassLevelLiteDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/madrasa-exam-assessment/examiner-classes',
      query: {
        examinerId: examinerId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getStudentsMadrasaExamReadinessForExaminer
   * @returns Page_ExaminerMadrasaExamStatusResponse_ OK
   * @throws ApiError
   */
  public static getStudentsMadrasaExamReadinessForExaminerUsingGet({
    examinerId,
    termId,
    classLevelId,
    limit = 10,
    offset,
    search,
  }: {
    /**
     * examinerId
     */
    examinerId: string;
    /**
     * termId
     */
    termId: string;
    /**
     * classLevelId
     */
    classLevelId?: string;
    /**
     * limit
     */
    limit?: number;
    /**
     * offset
     */
    offset?: number;
    /**
     * search
     */
    search?: string;
  }): CancelablePromise<Page_ExaminerMadrasaExamStatusResponse_> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/madrasa-exam-assessment/examiner-ready-for-exam',
      query: {
        classLevelId: classLevelId,
        examinerId: examinerId,
        limit: limit,
        offset: offset,
        search: search,
        termId: termId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getStudentsMadrasaExamReadinessForTeacher
   * @returns Page_TeacherMadrasaExamStatusResponse_ OK
   * @throws ApiError
   */
  public static getStudentsMadrasaExamReadinessForTeacherUsingGet({
    armId,
    classLevelId,
    subjectId,
    termId,
    limit = 10,
    offset,
    search,
  }: {
    /**
     * armId
     */
    armId: string;
    /**
     * classLevelId
     */
    classLevelId: string;
    /**
     * subjectId
     */
    subjectId: string;
    /**
     * termId
     */
    termId: string;
    /**
     * limit
     */
    limit?: number;
    /**
     * offset
     */
    offset?: number;
    /**
     * search
     */
    search?: string;
  }): CancelablePromise<Page_TeacherMadrasaExamStatusResponse_> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/madrasa-exam-assessment/readiness',
      query: {
        armId: armId,
        classLevelId: classLevelId,
        limit: limit,
        offset: offset,
        search: search,
        subjectId: subjectId,
        termId: termId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * toggleStudentExamReadiness
   * @returns string OK
   * @returns any Created
   * @throws ApiError
   */
  public static toggleStudentExamReadinessUsingPut({
    request,
  }: {
    /**
     * request
     */
    request: ToggleStudentExamReadinessRequest;
  }): CancelablePromise<'NOT_READY' | 'PASSED' | 'READY' | any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/madrasa-exam-assessment/readiness',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }
}
